export const ProductionGoalMeter = {
  flow: 'x',
  align: 'center flex-start',
  gap: 'A',
  padding: 'A',
  round: 'Z',
  background: 'inkMid',
  border: '1px solid inkBorder',

  LabelsWrap: {
    flow: 'y',
    gap: 'X',
    minWidth: 'D',
    GoalAmount: {
      flow: 'y',
      gap: 'X',
      Label: { text: '{{ goal | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Value: { text: (el, s) => s.goalAmount || '', fontSize: 'Z', fontWeight: '700', color: 'inkText' }
    },
    CurrentProduction: {
      flow: 'y',
      gap: 'X',
      Label: { text: '{{ current2 | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Value: { text: (el, s) => s.currentProduction || '', fontSize: 'Z', fontWeight: '700', color: 'teal' }
    }
  },

  BarWrap: {
    flex: '1',
    flow: 'y',
    gap: 'Y',
    ProgressBar: {
      width: '100%',
      height: 'Z',
      round: 'Y',
      background: 'inkBorder',
      overflow: 'hidden',
      Fill: {
        height: '100%',
        round: 'Y',
        transition: 'width 0.3s',
        width: (el, s) => {
          const goal = parseFloat(String(s.goalAmount || '0').replace(/[$,]/g, ''))
          const current = parseFloat(String(s.currentProduction || '0').replace(/[$,]/g, ''))
          const pct = goal > 0 ? Math.min(100, Math.round((current / goal) * 100)) : 0
          return `${pct}%`
        },
        background: (el, s) => {
          const goal = parseFloat(String(s.goalAmount || '0').replace(/[$,]/g, ''))
          const current = parseFloat(String(s.currentProduction || '0').replace(/[$,]/g, ''))
          const pct = goal > 0 ? (current / goal) * 100 : 0
          if (pct >= 80) return 'teal'
          if (pct >= 50) return 'amber'
          return 'red'
        }
      }
    },
    ScheduledProduction: {
      text: (el, s) => s.scheduledProduction ? `Scheduled: ${s.scheduledProduction}` : '',
      fontSize: 'Y',
      color: 'inkMuted'
    }
  }
}
